import { getSerialNoHint, getHierarchyTitle, getDivisionTitle, CentralLocal_getColor, CentralLocal_translate, Eol_getColor } from "./ViewHelper.fs.js";
import { FieldDefinition$2, Alignment, Field_mapOrEmpty, Field_filterEmptyValue, Field_toDateValue, Field_toUnitValue, Field_toCurrencyValue, Value } from "../../Fame.Fts.Shared/Shared.UI/Fields.fs.js";
import { CentralLocalModule_tryParse } from "./Context.fs.js";
import { contains, ofArray } from "./fable_modules/fable-library.3.7.12/Set.js";
import { uncurry, partialApply, comparePrimitives } from "./fable_modules/fable-library.3.7.12/Util.js";
import { printf, toText, join } from "./fable_modules/fable-library.3.7.12/String.js";
import { RouteModule_ofSparePartId, RouteModule_toLink } from "./Routing.fs.js";
import { ProjectIdModule_toString, ProductIdModule_toString, SalesListIdModule_toString, SparePartIdModule_toString, SparePartIdModule_ofString } from "../SparePartInfo/CommonTypes.fs.js";
import { toList } from "./fable_modules/fable-library.3.7.12/Seq.js";
import { ExternalUrl } from "./Constants.fs.js";
import { ofArray as ofArray_1 } from "./fable_modules/fable-library.3.7.12/List.js";

function toEolValue(loc, d) {
    return new Value(5, loc.FormatDate(d), Eol_getColor(d));
}

function toCentralLocalValue(loc, v) {
    const matchValue = [v, CentralLocalModule_tryParse(v)];
    if (matchValue[1] == null) {
        if (matchValue[0] === "") {
            return new Value(11);
        }
        else {
            return new Value(0, matchValue[0]);
        }
    }
    else {
        const cl = matchValue[1];
        return new Value(5, CentralLocal_translate(loc.Translation, cl), CentralLocal_getColor(cl));
    }
}

const SparePart_internalOnlyFields = ofArray(["lastCall", "repairOnly", "endOfServiceMax", "centralLocal", "criticalPart", "materialKind", "generalInfo", "precheckInfo", "inboundInfo", "returnInfo", "serialNoPrefix", "serialNoHint", "returnInfo", "supplier", "supplierCreditorNo", "supplierCreditorName", "repairer", "repairerCreditorNo", "repairerCreditorName", "repairerPartNo", "notInStore", "moreInfo", "engineer", "planner", "mS80"], {
    Compare: comparePrimitives,
});

export function SparePart_isPublic(field) {
    return !contains(field, SparePart_internalOnlyFields);
}

export function SparePart_translate(tr, _arg1) {
    switch (_arg1) {
        case "partNumber": {
            return tr.Field.PartNumber;
        }
        case "description": {
            return tr.Field.Description;
        }
        case "descriptionDE": {
            return tr.Field.DescriptionDE;
        }
        case "division": {
            return tr.Field.Division;
        }
        case "productHierarchy": {
            return tr.Field.Hierarchy;
        }
        case "vendorPartNo": {
            return tr.Field.VendorPartNo;
        }
        case "productCode": {
            return tr.Field.ProductCode;
        }
        case "technicalInfo": {
            return tr.Field.TechnicalInfo;
        }
        case "returnCode": {
            return tr.Field.ReturnCode;
        }
        case "repairCode": {
            return tr.Field.RepairCode;
        }
        case "listPrice": {
            return tr.Field.ListPrice;
        }
        case "endOfService": {
            return tr.Field.EndOfService;
        }
        case "endOfServiceMax": {
            return tr.Field.EndOfServiceMax;
        }
        case "creditPrice": {
            return tr.Field.CreditPrice;
        }
        case "currency": {
            return tr.Field.Currency;
        }
        case "cRU": {
            return tr.Field.CRU;
        }
        case "centralLocal": {
            return tr.Field.CentralLocal;
        }
        case "substituteMaterial": {
            return tr.Field.SubstituteMaterial;
        }
        case "alternativePart": {
            return tr.Field.AlternativePart;
        }
        case "mainAlternativePart": {
            return tr.Field.MainAlternativePart;
        }
        case "engineer": {
            return tr.Field.Engineer;
        }
        case "planner": {
            return tr.Field.Planner;
        }
        case "dataSecurity": {
            return tr.Field.DataSecurity;
        }
        case "mS80": {
            return tr.Field.MS80;
        }
        case "commodityCode": {
            return tr.Field.CommodityCode;
        }
        case "legalControlDE": {
            return tr.Field.LegalControlDE;
        }
        case "legalControlEN": {
            return tr.Field.LegalControlEN;
        }
        case "countryOfOrigin": {
            return tr.Field.CountryOfOrigin;
        }
        case "roHSKz": {
            return tr.Field.RoHSKz;
        }
        case "dangerousGoods": {
            return tr.Field.DangerousGoods;
        }
        case "hazardousMaterialNumber": {
            return tr.Field.HazardousMaterialNumber;
        }
        case "articleNumberBattery1": {
            return tr.Field.ArticleNumberBattery1;
        }
        case "articleNumberBattery2": {
            return tr.Field.ArticleNumberBattery2;
        }
        case "externalPackaging": {
            return tr.Field.ExternalPackaging;
        }
        case "internalPackaging": {
            return tr.Field.InternalPackaging;
        }
        case "eSDBag": {
            return tr.Field.ESDBag;
        }
        case "grossWeight": {
            return tr.Field.GrossWeight;
        }
        case "netWeight": {
            return tr.Field.NetWeight;
        }
        case "weightUnit": {
            return tr.Field.WeightUnit;
        }
        case "volume": {
            return tr.Field.Volume;
        }
        case "volumeUnit": {
            return tr.Field.VolumeUnit;
        }
        case "length": {
            return tr.Field.Length;
        }
        case "width": {
            return tr.Field.Width;
        }
        case "height": {
            return tr.Field.Height;
        }
        case "dimensions": {
            return join(" / ", [tr.Field.Length, tr.Field.Width, tr.Field.Height]);
        }
        case "dimensionUnit": {
            return tr.Field.DimensionUnit;
        }
        case "criticalPart": {
            return tr.Field.CriticalPart;
        }
        case "supplier": {
            return tr.Field.Supplier;
        }
        case "supplierCreditorNo": {
            return tr.Field.SupplierCreditorNo;
        }
        case "supplierCreditorName": {
            return tr.Field.Supplier;
        }
        case "repairer": {
            return tr.Field.Repairer;
        }
        case "repairerCreditorNo": {
            return tr.Field.RepairerCreditorNo;
        }
        case "repairerCreditorName": {
            return tr.Field.Repairer;
        }
        case "repairerPartNo": {
            return tr.Field.RepairerPartNo;
        }
        case "generalInfo": {
            return tr.Field.GeneralInfo;
        }
        case "precheckInfo": {
            return tr.Field.PrecheckInfo;
        }
        case "inboundInfo": {
            return tr.Field.InboundInfo;
        }
        case "returnInfo": {
            return tr.Field.ReturnInfo;
        }
        case "serialNoPrefix": {
            return tr.Field.SerialNoPrefix;
        }
        case "serialNoHint": {
            return tr.Field.SerialNoHint;
        }
        case "materialKind": {
            return tr.Field.MaterialKind;
        }
        case "notInStore": {
            return tr.Field.NotInStore;
        }
        case "moreInfo": {
            return tr.Field.MoreInfo;
        }
        case "useUp": {
            return tr.Field.UseUp;
        }
        case "lastCall": {
            return tr.Field.LastCall;
        }
        case "repairOnly": {
            return tr.Field.RepairOnly;
        }
        case "creationDate": {
            return tr.Field.CreationDate;
        }
        case "usedInProducts": {
            return tr.Field.UsedInProducts;
        }
        case "usedInSalesLists": {
            return tr.Field.UsedInSalesLists;
        }
        default: {
            return tr.Field.MaterialNo;
        }
    }
}

export function SparePart_getValue(loc, sparePart) {
    const toCurrencyValue = (value) => Field_toCurrencyValue(loc.BaseLocalization, sparePart.Currency, value);
    const toUnitValue = (unit, value_1) => Field_toUnitValue(loc.BaseLocalization, unit, value_1);
    const toDateValue = Field_toDateValue(loc.BaseLocalization);
    const toSparePartLinkValue = (_arg1) => {
        if (_arg1 === "") {
            return new Value(11);
        }
        else {
            const idStr = _arg1;
            return new Value(6, idStr, RouteModule_toLink(RouteModule_ofSparePartId(SparePartIdModule_ofString(idStr))), (value_2) => {
            });
        }
    };
    return (arg) => {
        let _arg2, matchValue;
        return Field_filterEmptyValue((_arg2 = arg, (_arg2 === "partNumber") ? (new Value(0, sparePart.PartNumber)) : ((_arg2 === "description") ? (new Value(0, sparePart.Description)) : ((_arg2 === "descriptionDE") ? (new Value(0, sparePart.DescriptionDE)) : ((_arg2 === "division") ? (new Value(0, getDivisionTitle(loc, sparePart.Division))) : ((_arg2 === "productHierarchy") ? (new Value(0, getHierarchyTitle(loc, sparePart.ProductHierarchy))) : ((_arg2 === "vendorPartNo") ? (new Value(0, sparePart.VendorPartNo)) : ((_arg2 === "productCode") ? (new Value(0, sparePart.ProductCode)) : ((_arg2 === "technicalInfo") ? (new Value(1, toList(sparePart.TechnicalInfo))) : ((_arg2 === "returnCode") ? (new Value(0, sparePart.ReturnCode)) : ((_arg2 === "repairCode") ? (new Value(0, sparePart.RepairCode)) : ((_arg2 === "listPrice") ? Field_mapOrEmpty(toCurrencyValue, sparePart.ListPrice) : ((_arg2 === "endOfService") ? Field_mapOrEmpty((d) => toEolValue(loc, d), sparePart.EndOfService) : ((_arg2 === "endOfServiceMax") ? Field_mapOrEmpty(toDateValue, sparePart.EndOfServiceMax) : ((_arg2 === "creditPrice") ? Field_mapOrEmpty(toCurrencyValue, sparePart.CreditPrice) : ((_arg2 === "currency") ? (new Value(0, sparePart.Currency)) : ((_arg2 === "cRU") ? (new Value(8, sparePart.CRU)) : ((_arg2 === "centralLocal") ? toCentralLocalValue(loc, sparePart.CentralLocal) : ((_arg2 === "substituteMaterial") ? toSparePartLinkValue(sparePart.SubstituteMaterial) : ((_arg2 === "alternativePart") ? toSparePartLinkValue(sparePart.AlternativePart) : ((_arg2 === "mainAlternativePart") ? toSparePartLinkValue(sparePart.MainAlternativePart) : ((_arg2 === "engineer") ? (new Value(0, sparePart.Engineer)) : ((_arg2 === "planner") ? (new Value(0, sparePart.Planner)) : ((_arg2 === "dataSecurity") ? (new Value(0, sparePart.DataSecurity)) : ((_arg2 === "mS80") ? Field_mapOrEmpty(toDateValue, sparePart.MS80) : ((_arg2 === "commodityCode") ? (new Value(0, sparePart.CommodityCode)) : ((_arg2 === "legalControlDE") ? (new Value(0, sparePart.LegalControlDE)) : ((_arg2 === "legalControlEN") ? (new Value(0, sparePart.LegalControlEN)) : ((_arg2 === "countryOfOrigin") ? (new Value(0, sparePart.CountryOfOrigin)) : ((_arg2 === "roHSKz") ? (new Value(0, sparePart.RoHSKz)) : ((_arg2 === "dangerousGoods") ? (new Value(0, sparePart.DangerousGoods)) : ((_arg2 === "hazardousMaterialNumber") ? (new Value(0, sparePart.HazardousMaterialNumber)) : ((_arg2 === "articleNumberBattery1") ? (new Value(0, sparePart.ArticleNumberBattery1)) : ((_arg2 === "articleNumberBattery2") ? (new Value(0, sparePart.ArticleNumberBattery2)) : ((_arg2 === "externalPackaging") ? (new Value(7, sparePart.ExternalPackaging, ExternalUrl.PackingImage(sparePart.ExternalPackaging))) : ((_arg2 === "internalPackaging") ? (new Value(7, sparePart.InternalPackaging, ExternalUrl.PackingImage(sparePart.InternalPackaging))) : ((_arg2 === "eSDBag") ? (new Value(7, sparePart.ESDBag, ExternalUrl.PackingImage(sparePart.ESDBag))) : ((_arg2 === "grossWeight") ? Field_mapOrEmpty(partialApply(1, toUnitValue, [sparePart.WeightUnit]), sparePart.GrossWeight) : ((_arg2 === "netWeight") ? Field_mapOrEmpty(partialApply(1, toUnitValue, [sparePart.WeightUnit]), sparePart.NetWeight) : ((_arg2 === "weightUnit") ? (new Value(0, sparePart.WeightUnit)) : ((_arg2 === "volume") ? Field_mapOrEmpty(partialApply(1, toUnitValue, [sparePart.VolumeUnit]), sparePart.Volume) : ((_arg2 === "volumeUnit") ? (new Value(0, sparePart.VolumeUnit)) : ((_arg2 === "length") ? Field_mapOrEmpty(partialApply(1, toUnitValue, [sparePart.DimensionUnit]), sparePart.Length) : ((_arg2 === "width") ? Field_mapOrEmpty(partialApply(1, toUnitValue, [sparePart.DimensionUnit]), sparePart.Width) : ((_arg2 === "height") ? Field_mapOrEmpty(partialApply(1, toUnitValue, [sparePart.DimensionUnit]), sparePart.Height) : ((_arg2 === "dimensions") ? (new Value(10, " / ", ofArray_1([SparePart_getValue(loc, sparePart)("length"), SparePart_getValue(loc, sparePart)("width"), SparePart_getValue(loc, sparePart)("height")]))) : ((_arg2 === "dimensionUnit") ? (new Value(0, sparePart.DimensionUnit)) : ((_arg2 === "criticalPart") ? ((matchValue = sparePart.CriticalPart, (matchValue == null) ? (new Value(0, loc.Translation.Na)) : (new Value(8, matchValue)))) : ((_arg2 === "supplier") ? (new Value(10, " / ", ofArray_1([SparePart_getValue(loc, sparePart)("supplierCreditorNo"), SparePart_getValue(loc, sparePart)("supplierCreditorName")]))) : ((_arg2 === "supplierCreditorNo") ? (new Value(0, sparePart.SupplierCreditorNo)) : ((_arg2 === "supplierCreditorName") ? (new Value(0, sparePart.SupplierCreditorName)) : ((_arg2 === "repairer") ? (new Value(10, " / ", ofArray_1([SparePart_getValue(loc, sparePart)("repairerCreditorNo"), SparePart_getValue(loc, sparePart)("repairerCreditorName")]))) : ((_arg2 === "repairerCreditorNo") ? (new Value(0, sparePart.RepairerCreditorNo)) : ((_arg2 === "repairerCreditorName") ? (new Value(0, sparePart.RepairerCreditorName)) : ((_arg2 === "repairerPartNo") ? (new Value(0, sparePart.RepairerPartNo)) : ((_arg2 === "generalInfo") ? (new Value(1, toList(sparePart.GeneralInfo))) : ((_arg2 === "precheckInfo") ? (new Value(1, toList(sparePart.PrecheckInfo))) : ((_arg2 === "inboundInfo") ? (new Value(10, " ", ofArray_1([new Value(1, toList(sparePart.InboundInfo)), new Value(7, loc.Translation.Edit, ExternalUrl.MaterialInboundInfo(sparePart.MaterialNo))]))) : ((_arg2 === "returnInfo") ? (new Value(10, " ", ofArray_1([new Value(1, toList(sparePart.ReturnInfo)), new Value(7, loc.Translation.Edit, ExternalUrl.MaterialReturnInfo(sparePart.MaterialNo))]))) : ((_arg2 === "serialNoPrefix") ? (new Value(0, sparePart.SerialNoPrefix)) : ((_arg2 === "serialNoHint") ? (new Value(0, getSerialNoHint(loc, sparePart.SerialNoPrefix))) : ((_arg2 === "materialKind") ? (new Value(0, sparePart.MaterialKind)) : ((_arg2 === "notInStore") ? (new Value(8, sparePart.NotInStore)) : ((_arg2 === "moreInfo") ? (new Value(8, sparePart.MoreInfo)) : ((_arg2 === "useUp") ? (new Value(8, sparePart.UseUp)) : ((_arg2 === "lastCall") ? (new Value(8, sparePart.LastCall)) : ((_arg2 === "repairOnly") ? (new Value(8, sparePart.RepairOnly)) : ((_arg2 === "creationDate") ? Field_mapOrEmpty(toDateValue, sparePart.CreationDate) : ((_arg2 === "usedInProducts") ? (new Value(0, toText(printf("%d"))(sparePart.UsedInProducts))) : ((_arg2 === "usedInSalesLists") ? (new Value(0, toText(printf("%d"))(sparePart.UsedInSalesLists))) : (new Value(4, SparePartIdModule_toString(sparePart.MaterialNo)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    };
}

export const SparePart_all = ["materialNo", "partNumber", "description", "descriptionDE", "division", "productHierarchy", "vendorPartNo", "productCode", "technicalInfo", "returnCode", "repairCode", "listPrice", "endOfService", "endOfServiceMax", "creditPrice", "currency", "cRU", "substituteMaterial", "alternativePart", "centralLocal", "mainAlternativePart", "engineer", "planner", "dataSecurity", "mS80", "commodityCode", "legalControlDE", "legalControlEN", "countryOfOrigin", "roHSKz", "dangerousGoods", "hazardousMaterialNumber", "articleNumberBattery1", "articleNumberBattery2", "externalPackaging", "internalPackaging", "eSDBag", "grossWeight", "netWeight", "weightUnit", "volume", "volumeUnit", "length", "width", "height", "dimensions", "dimensionUnit", "criticalPart", "supplier", "supplierCreditorNo", "supplierCreditorName", "repairer", "repairerCreditorNo", "repairerCreditorName", "generalInfo", "precheckInfo", "inboundInfo", "returnInfo", "serialNoPrefix", "serialNoHint", "materialKind", "notInStore", "moreInfo", "useUp", "lastCall", "repairOnly", "creationDate", "usedInProducts", "usedInSalesLists"];

export const SparePart_defaultTableCols = ["materialNo", "partNumber", "description", "division", "criticalPart", "returnCode", "listPrice", "creditPrice", "centralLocal"];

export function SparePart_definition(loc) {
    return new FieldDefinition$2(SparePart_isPublic, (_arg1) => SparePart_translate(loc.Translation, _arg1), uncurry(2, (sparePart) => SparePart_getValue(loc, sparePart)), (_arg1_1) => (new Alignment(0)));
}

export function Battery_isPublic(_arg1) {
    return true;
}

export function Battery_translate(tr, _arg1) {
    switch (_arg1) {
        case "bATTKZ": {
            return tr.Field.BATTKZ;
        }
        case "battchargetype": {
            return tr.Field.Battchargetype;
        }
        case "battmatcomp": {
            return tr.Field.Battmatcomp;
        }
        case "battdef1": {
            return tr.Field.Battdef1;
        }
        case "lIContent": {
            return tr.Field.LIContent;
        }
        case "capperBatt": {
            return tr.Field.CapperBatt;
        }
        case "bATTCELLS": {
            return tr.Field.BATTCELLS;
        }
        case "battweight": {
            return tr.Field.Battweight;
        }
        case "manufacturer": {
            return tr.Field.Manufacturer;
        }
        default: {
            return tr.Field.IECCode;
        }
    }
}

export function Battery_getValue(loc, battery) {
    return (arg_1) => {
        let _arg1, f1, clo1;
        return Field_filterEmptyValue((_arg1 = arg_1, (_arg1 === "bATTKZ") ? (new Value(0, battery.BATTKZ)) : ((_arg1 === "battchargetype") ? (new Value(0, battery.Battchargetype)) : ((_arg1 === "battmatcomp") ? (new Value(0, battery.Battmatcomp)) : ((_arg1 === "battdef1") ? (new Value(0, battery.Battdef1)) : ((_arg1 === "lIContent") ? (new Value(0, battery.LIContent)) : ((_arg1 === "capperBatt") ? (new Value(0, battery.CapperBatt)) : ((_arg1 === "bATTCELLS") ? Field_mapOrEmpty((f1 = ((clo1 = toText(printf("%d")), clo1)), (arg) => (new Value(0, f1(arg)))), battery.BATTCELLS) : ((_arg1 === "battweight") ? Field_mapOrEmpty((value) => Field_toUnitValue(loc, battery.BattweightUnit, value), battery.Battweight) : ((_arg1 === "manufacturer") ? (new Value(0, battery.Manufacturer)) : (new Value(0, battery.IECCode))))))))))));
    };
}

export function Battery_definition(loc) {
    return new FieldDefinition$2(Battery_isPublic, (_arg1) => Battery_translate(loc.Translation, _arg1), uncurry(2, (battery) => Battery_getValue(loc.BaseLocalization, battery)), (_arg1_1) => (new Alignment(0)));
}

const P84_internalOnlyFields = ofArray(["vmsta01", "vmsta31", "jpdmMmsta", "p84Mmsta"], {
    Compare: comparePrimitives,
});

export function P84_isPublic(field) {
    return !contains(field, P84_internalOnlyFields);
}

export function P84_translate(tr, _arg1) {
    switch (_arg1) {
        case "description": {
            return tr.Field.Description;
        }
        case "salesText": {
            return tr.Field.SalesText;
        }
        case "vmsta01": {
            return tr.Field.Vmsta_01;
        }
        case "vmsta31": {
            return tr.Field.Vmsta_31;
        }
        case "jpdmMmsta": {
            return tr.Field.JpdmMmsta;
        }
        case "p84Mmsta": {
            return tr.Field.P84Mmsta;
        }
        case "orderableFrom": {
            return tr.Field.OrderableFrom;
        }
        case "deliverableFrom": {
            return tr.Field.DeliverableFrom;
        }
        case "limitedAvailability": {
            return tr.Field.LimitedAvailability;
        }
        case "eolControlDate": {
            return tr.Field.EolControlDate;
        }
        default: {
            return tr.Field.MaterialNo;
        }
    }
}

export function P84_getValue(loc, p84) {
    const toDateValue = Field_toDateValue(loc);
    return (arg) => {
        let _arg1;
        return Field_filterEmptyValue((_arg1 = arg, (_arg1 === "description") ? (new Value(0, p84.Description)) : ((_arg1 === "salesText") ? (new Value(0, p84.SalesText)) : ((_arg1 === "vmsta01") ? (new Value(0, p84.Vmsta_01)) : ((_arg1 === "vmsta31") ? (new Value(0, p84.Vmsta_31)) : ((_arg1 === "jpdmMmsta") ? (new Value(0, p84.JpdmMmsta)) : ((_arg1 === "p84Mmsta") ? (new Value(0, p84.P84Mmsta)) : ((_arg1 === "orderableFrom") ? Field_mapOrEmpty(toDateValue, p84.OrderableFrom) : ((_arg1 === "deliverableFrom") ? Field_mapOrEmpty(toDateValue, p84.DeliverableFrom) : ((_arg1 === "limitedAvailability") ? (new Value(0, p84.LimitedAvailability)) : ((_arg1 === "eolControlDate") ? Field_mapOrEmpty(toDateValue, p84.EolControlDate) : (new Value(0, p84.MaterialNo)))))))))))));
    };
}

export function P84_definition(loc) {
    return new FieldDefinition$2(P84_isPublic, (_arg1) => P84_translate(loc.Translation, _arg1), uncurry(2, (p84) => P84_getValue(loc.BaseLocalization, p84)), (_arg1_1) => (new Alignment(0)));
}

export function SalesList_isPublic(_arg1) {
    return true;
}

export function SalesList_translate(tr, _arg1) {
    switch (_arg1) {
        case "partNumber": {
            return tr.Field.PartNumber;
        }
        case "description": {
            return tr.Field.Description;
        }
        case "usedInSpareParts": {
            return tr.Field.UsedInSpareParts;
        }
        case "usedInProducts": {
            return tr.Field.UsedInProducts;
        }
        default: {
            return tr.Field.MaterialNo;
        }
    }
}

export function SalesList_getValue(_loc, salesList) {
    return (arg) => {
        let _arg1;
        return Field_filterEmptyValue((_arg1 = arg, (_arg1 === "partNumber") ? (new Value(0, salesList.PartNumber)) : ((_arg1 === "description") ? (new Value(0, salesList.Description)) : ((_arg1 === "usedInSpareParts") ? (new Value(0, toText(printf("%d"))(salesList.UsedInSpareParts))) : ((_arg1 === "usedInProducts") ? (new Value(0, toText(printf("%d"))(salesList.UsedInProducts))) : (new Value(4, SalesListIdModule_toString(salesList.MaterialNo))))))));
    };
}

export const SalesList_all = ["materialNo", "partNumber", "description", "usedInSpareParts", "usedInProducts"];

export const SalesList_defaultTableCols = ["materialNo", "partNumber", "description"];

export function SalesList_definition(loc) {
    return new FieldDefinition$2(SalesList_isPublic, (_arg1) => SalesList_translate(loc.Translation, _arg1), uncurry(2, (salesList) => SalesList_getValue(loc.BaseLocalization, salesList)), (_arg1_1) => (new Alignment(0)));
}

const Product_internalOnlyFields = ofArray(["planningInformation", "endOfServiceMax"], {
    Compare: comparePrimitives,
});

export function Product_isPublic(field) {
    return !contains(field, Product_internalOnlyFields);
}

export function Product_translate(tr, _arg1) {
    switch (_arg1) {
        case "productNo": {
            return tr.Field.ProductNo;
        }
        case "partNumber": {
            return tr.Field.PartNumber;
        }
        case "description": {
            return tr.Field.Description;
        }
        case "descriptionDE": {
            return tr.Field.DescriptionDE;
        }
        case "productGroupPlant": {
            return tr.Field.ProductGroupPlant;
        }
        case "productHierarchy": {
            return tr.Field.Hierarchy;
        }
        case "endOfService": {
            return tr.Field.EndOfService;
        }
        case "endOfServiceMax": {
            return tr.Field.EndOfServiceMax;
        }
        case "cRU": {
            return tr.Field.CRU;
        }
        case "centralLocal": {
            return tr.Field.CentralLocal;
        }
        case "planningInformation": {
            return tr.Field.PlanningInformation;
        }
        case "engineer": {
            return tr.Field.Engineer;
        }
        case "eXTWG": {
            return tr.Field.EXTWG;
        }
        case "mS80": {
            return tr.Field.MS80;
        }
        case "creationDate": {
            return tr.Field.CreationDate;
        }
        case "usedInSpareParts": {
            return tr.Field.UsedInSpareParts;
        }
        case "usedInSalesLists": {
            return tr.Field.UsedInSalesLists;
        }
        case "usedInProjects": {
            return tr.Field.UsedInProjects;
        }
        default: {
            return tr.Field.MaterialNo;
        }
    }
}

export function Product_getValue(loc, product) {
    const toDateValue = Field_toDateValue(loc.BaseLocalization);
    return (arg) => {
        let _arg1;
        return Field_filterEmptyValue((_arg1 = arg, (_arg1 === "productNo") ? (new Value(0, product.ProductNo)) : ((_arg1 === "partNumber") ? (new Value(0, product.PartNumber)) : ((_arg1 === "description") ? (new Value(0, product.Description)) : ((_arg1 === "descriptionDE") ? (new Value(0, product.DescriptionDE)) : ((_arg1 === "productGroupPlant") ? (new Value(0, product.ProductGroupPlant)) : ((_arg1 === "productHierarchy") ? (new Value(0, product.ProductHierarchy)) : ((_arg1 === "endOfService") ? Field_mapOrEmpty((d) => toEolValue(loc, d), product.EndOfService) : ((_arg1 === "endOfServiceMax") ? Field_mapOrEmpty(toDateValue, product.EndOfServiceMax) : ((_arg1 === "cRU") ? (new Value(8, product.CRU)) : ((_arg1 === "centralLocal") ? toCentralLocalValue(loc, product.CentralLocal) : ((_arg1 === "planningInformation") ? (new Value(10, " ", ofArray_1([new Value(1, toList(product.PlanningInformation)), new Value(7, loc.Translation.Edit, ExternalUrl.ProductPlanningInfo(product.MaterialNo))]))) : ((_arg1 === "engineer") ? (new Value(0, product.Engineer)) : ((_arg1 === "eXTWG") ? (new Value(0, product.EXTWG)) : ((_arg1 === "mS80") ? Field_mapOrEmpty(toDateValue, product.MS80) : ((_arg1 === "creationDate") ? Field_mapOrEmpty(toDateValue, product.CreationDate) : ((_arg1 === "usedInSpareParts") ? (new Value(0, toText(printf("%d"))(product.UsedInSpareParts))) : ((_arg1 === "usedInSalesLists") ? (new Value(0, toText(printf("%d"))(product.UsedInSalesLists))) : ((_arg1 === "usedInProjects") ? (new Value(0, toText(printf("%d"))(product.UsedInProjects))) : (new Value(4, ProductIdModule_toString(product.MaterialNo))))))))))))))))))))));
    };
}

export const Product_all = ["materialNo", "partNumber", "description", "descriptionDE", "productNo", "productGroupPlant", "productHierarchy", "cRU", "centralLocal", "endOfService", "endOfServiceMax", "planningInformation", "mS80", "engineer", "eXTWG", "creationDate", "usedInSpareParts", "usedInSalesLists", "usedInProjects"];

export const Product_defaultTableCols = ["materialNo", "productNo", "partNumber", "description", "endOfService"];

export function Product_definition(loc) {
    return new FieldDefinition$2(Product_isPublic, (_arg1) => Product_translate(loc.Translation, _arg1), uncurry(2, (product) => Product_getValue(loc, product)), (_arg1_1) => (new Alignment(0)));
}

export function Project_isPublic(_arg1) {
    return true;
}

export function Project_translate(tr, _arg1) {
    switch (_arg1) {
        case "productNo": {
            return tr.Field.ProductNo;
        }
        case "partNumber": {
            return tr.Field.PartNumber;
        }
        case "description": {
            return tr.Field.Description;
        }
        case "descriptionDE": {
            return tr.Field.DescriptionDE;
        }
        case "productGroupPlant": {
            return tr.Field.ProductGroupPlant;
        }
        case "productHierarchy": {
            return tr.Field.Hierarchy;
        }
        case "endOfService": {
            return tr.Field.EndOfService;
        }
        case "endOfServiceMax": {
            return tr.Field.EndOfServiceMax;
        }
        case "engineer": {
            return tr.Field.Engineer;
        }
        case "usedInProducts": {
            return tr.Field.UsedInProducts;
        }
        default: {
            return tr.Field.MaterialNo;
        }
    }
}

export function Project_getValue(loc, project) {
    return (arg) => {
        let _arg1;
        return Field_filterEmptyValue((_arg1 = arg, (_arg1 === "productNo") ? (new Value(0, project.ProductNo)) : ((_arg1 === "partNumber") ? (new Value(0, project.PartNumber)) : ((_arg1 === "description") ? (new Value(0, project.Description)) : ((_arg1 === "descriptionDE") ? (new Value(0, project.DescriptionDE)) : ((_arg1 === "productGroupPlant") ? (new Value(0, project.ProductGroupPlant)) : ((_arg1 === "productHierarchy") ? (new Value(0, project.ProductHierarchy)) : ((_arg1 === "endOfService") ? Field_mapOrEmpty((d) => toEolValue(loc, d), project.EndOfService) : ((_arg1 === "endOfServiceMax") ? Field_mapOrEmpty(Field_toDateValue(loc.BaseLocalization), project.EndOfServiceMax) : ((_arg1 === "engineer") ? (new Value(0, project.Engineer)) : ((_arg1 === "usedInProducts") ? (new Value(0, toText(printf("%d"))(project.UsedInProducts))) : (new Value(4, ProjectIdModule_toString(project.MaterialNo))))))))))))));
    };
}

export const Project_all = ["materialNo", "productNo", "partNumber", "description", "descriptionDE", "productGroupPlant", "productHierarchy", "endOfService", "endOfServiceMax", "engineer", "usedInProducts"];

export const Project_defaultTableCols = ["materialNo", "productNo", "partNumber", "description", "endOfService"];

export function Project_definition(loc) {
    return new FieldDefinition$2(Project_isPublic, (_arg1) => Project_translate(loc.Translation, _arg1), uncurry(2, (project) => Project_getValue(loc, project)), (_arg1_1) => (new Alignment(0)));
}

